(function ($, Drupal) {
  Drupal.behaviors.heimatMenu = {
    attach: function (context, settings) {

      once('heimatMenuOpen', '#menu-open', context).forEach((e) => {

        $(e).on('click', function() {
          $('.site-header--hamburger, .nrw-logo').addClass('d-none');
          $('.site-header--navigation, .hamburger-close').removeClass('d-none').addClass('d-flex');
        });
      });

      once('heimatMenuClose', '#menu-close', context).forEach((e) => {

        $(e).on('click', function() {
          $(' .site-header--hamburger, .nrw-logo').removeClass('d-none');
          $('.site-header--navigation, .hamburger-close').addClass('d-none').removeClass('d-flex');
        });
      });


    }
  }
})(jQuery, Drupal);
